module.exports = __webpack_public_path__ + "c07c962a9ff8921b95eead83a8876f78.gif";


//////////////////
// WEBPACK FOOTER
// ./src/viega-common/components/loading-spinner/img/ajax-loader.gif
// module id = 2j6z
// module chunks = 5